"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellFormatChecker = void 0;
const store_1 = require("../exports/store");
const model_1 = require("../model");
const immer_1 = __importDefault(require("immer"));
const types_1 = require("../types");
class CellFormatChecker {
    constructor(store) {
        this.store = store;
    }
    static checkValueValid(cellValue, field, state) {
        if (model_1.Field.bindContext(field, state).validate(cellValue)) {
            return cellValue;
        }
        return null;
    }
    convertValue(fieldId, recordId, cellValue, fieldMapSnapshot, datasheetId) {
        const state = this.store.getState();
        const currentField = store_1.Selectors.getField(state, fieldId, datasheetId);
        const previousField = fieldMapSnapshot[fieldId];
        if (fieldMapSnapshot[currentField.id].type === currentField.type) {
            return CellFormatChecker.checkValueValid(cellValue, currentField, state);
        }
        const stdValue = model_1.Field.bindContext(previousField, state).cellValueToStdValue(cellValue);
        const result = model_1.Field.bindContext(currentField, state).stdValueToCellValue(stdValue);
        // Because the data has been corrected, 
        // the old data structure will be updated at the same time to prevent the data from being correct 
        // and the recorded FieldType is still wrong, resulting in an error in the middle layer
        fieldMapSnapshot[currentField.id] = currentField;
        if (cellValue && !result && currentField.type === types_1.FieldType.Link) {
            // Fix the data exception caused by the lack of associated ops in this table
            return store_1.Selectors.getCellValue(state, store_1.Selectors.getSnapshot(state), recordId, currentField.id);
        }
        return result;
    }
    parse(actions, datasheetId, fieldMapSnapshot) {
        if (!fieldMapSnapshot) {
            return actions;
        }
        const fieldIds = Object.keys(fieldMapSnapshot);
        return (0, immer_1.default)(actions, draft => {
            for (const action of draft) {
                if (!action.p.includes('recordMap')) {
                    continue;
                }
                if (!action['oi']) {
                    continue;
                }
                const recordId = action.p[1];
                if (action.p.length === 4) {
                    if (!fieldIds.includes(action.p[3])) {
                        continue;
                    }
                    const fieldId = action.p[3];
                    const cellValue = action['oi'];
                    action['oi'] = this.convertValue(fieldId, recordId, cellValue, fieldMapSnapshot, datasheetId);
                }
                if (action.p.length === 2 && 'data' in action['oi']) {
                    for (const fieldId of fieldIds) {
                        const cellValue = action['oi'].data[fieldId];
                        action['oi'].data[fieldId] = this.convertValue(fieldId, recordId, cellValue, fieldMapSnapshot, datasheetId);
                    }
                }
            }
            return draft;
        });
    }
}
exports.CellFormatChecker = CellFormatChecker;
//# sourceMappingURL=cell_format_checker.js.map